import { camelCaseToRegularCase } from "./camelCaseToRegularCase";

export const agentTypeRename = (agentType: string) => {
    switch (agentType) {
        case "orderProcessing":
            return "Email Orders";
        case "marketingCampaign":
            return "Marketing Campaigns";
        case "EDIAssistant":
            return "EDI Orders";
        case "InventoryManagement":
            return "Inventory Report";
        default:
            return camelCaseToRegularCase(agentType);
    }
};
